import styled, { css } from 'styled-components';
import { Modal } from 'modules/Modal';
import { themeGet } from 'modules/tetrisTheme';
function getPositionCSS(position) {
    if (position === 'right') {
        return css `
      margin-left: auto;
    `;
    }
    return undefined;
}
function getTransitionCSS(state, position) {
    const endPosition = position === 'left' ? '-100%' : '100%';
    switch (state) {
        case 'visible':
            return css `
        transform: translate(0, 0);
      `;
        case 'entering':
        case 'leaving':
        case 'hidden':
            return css `
        transform: translate(${endPosition}, 0);
      `;
        default:
            return undefined;
    }
}
export const Container = styled.div `
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  transition: transform 0.2s ease-in-out;
  transition-delay: 5ms;
  box-shadow: ${themeGet('dropShadow.300')};
  ${(props) => getPositionCSS(props.$position)}
  ${(props) => getTransitionCSS(props.$state, props.$position)}
`;
export const StyledModal = styled(Modal) `
  background-color: transparent;
`;
